import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import NewDeviceModal from './NewDevice';

const ArtikelSelectModal = ({ open, onClose, onSelect, options = [], debtorId, articleId }) => {
  const [search, setSearch] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [newDeviceModalOpen, setNewDeviceModalOpen] = useState(false);

  console.log(options);
  console.log({ debtorId });
  console.log({ articleId });

  useEffect(() => {
    setFilteredOptions(
      options.filter((item) => (item.Naam_Apparaat || '').toLowerCase().includes(search.toLowerCase()))
    );
  }, [search, options]);

  const handleSelect = (device) => {
    onSelect(device);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Selecteer artikel</DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth
          variant="outlined"
          label="Zoeken"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mb: 2 }}
        />
        <List>
          {filteredOptions.map((device, idx) => (
            <ListItem key={idx} disablePadding>
              <ListItemButton onClick={() => handleSelect(device)}>
                <ListItemText
                  primary={device.Naam_Apparaat || '(Geen naam)'}
                  secondary={
                    <>
                      <Typography component="span" variant="body2" color="text.secondary">
                        Omschrijving: {device.Onderwerp || '—'}
                      </Typography>
                      <br />
                      <Typography component="span" variant="body2" color="text.secondary">
                        Artikel: {device.Gekoppelde_artikel_omschrijving || ''}
                      </Typography>
                    </>
                  }
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
          Nog niet gevonden?
        </Typography>
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          sx={{ mt: 1 }}
          onClick={() => setNewDeviceModalOpen(true)}
        >
          + Nieuw artikel toevoegen
        </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Sluiten</Button>
      </DialogActions>
      <NewDeviceModal
        open={newDeviceModalOpen}
        onClose={() => setNewDeviceModalOpen(false)}
        onSubmit={(newDevice) => {
          // Add it to your options array (either to state or API)
          console.log('New device added:', newDevice);
        }}
        debtorId={debtorId}
        articleId={articleId}
      />
    </Dialog>
  );
};

export default ArtikelSelectModal;
